import { isEmpty, map } from 'lodash';
import React, { useMemo } from 'react';
import useT from '../../utils/Translations/useT';
import { RETURN_TYPE } from '../base/SelectBox';
import useResetOnDeps from './hooks/useResetOnDeps';
import MultiselectFilter from './MultiselectFilter';
import SelectBoxFilter from './SelectBoxFilter';
const LibrarySelector = ({ models, value, onChange, isSingleSelect = false, ...rest }) => {
    const t = useT();
    const modelsIds = useMemo(() => (isSingleSelect ? [] : map(models, 'id')), [
        isSingleSelect,
        models,
    ]);
    const title = useMemo(() => t('Library'), [t]);
    const isDisabled = useMemo(() => !models || isEmpty(models), [models]);
    const defaultValue = useMemo(() => {
        if (value)
            return value;
        if (isSingleSelect) {
            return '';
        }
        if (isDisabled) {
            return [];
        }
        return modelsIds;
    }, [isDisabled, isSingleSelect, modelsIds, value]);
    useResetOnDeps({ models, isDisabled }, onChange, defaultValue);
    return isSingleSelect ? (<SelectBoxFilter disabled={isDisabled} itemValuePropName="id" options={models} returnType={RETURN_TYPE.OPTION} title={title} value={value} onChange={onChange} {...rest}/>) : (<MultiselectFilter isEmptyAllowed showSelectAll showStatus disabled={isDisabled} options={models} title={title} value={value} onChange={onChange} {...rest}/>);
};
export default LibrarySelector;
